export const home = {
  // -----
  section01: {
    title: "The Importance of Curtains and Blinds",
    content: [
      "Curtains and blinds have similar functional purposes and have numerous identical traits. They are designed as window coverings and perform multiple tasks including blocking sunlight, controlling light permeability, and privacy.",
      "With New Zealand ’s fast-evolving lifestyle and improvement of the residents’ quality of life, curtains and blinds have extended their functional value to aesthetics and are thus now crucial elements in a home’s interior design.",
      "Curtains easily complement any interior design. They come in varieties such as day and night curtains that are available in a spectrum of material and styles.",
      "Blinds are neat, feasible and minimalist. They widen the options in light filtering and design options."
    ]
  },
  section02: {
    title: "You'll love what we do",
    content: [
      "Looking for the latest designs for your window dressings? Our collections of made-to-measure window coverings are sure to offer a design that catches your eye.",
      "And that’s not all. Our fantastic in-home service and experienced advisor team means you’ll get all the advice you need to make just the right decision for your home and lifestyle. Measured and fitted by the experts for a perfect finish every time.",
      "There’s a lot to love about what we do. So request your in-home appointment today."
    ]
  },

  section03: {
    title: "Window Covering Specialists",
    content: [
      "We are a leading provider of high quality window treatments servicing in Auckland area. We specialize in the finest curtains, shades, blinds, drapes and other window treatments from the leading manufacturers.",
      "With many years of experience, our relationships enable us to bring our clients the finest products. Whether you are looking for window treatments for your home or office, we have the variety that you need at the lowest prices. In addition to the high quality products, we offer the best professional installation and related services, with outstanding customer service."
    ]
  },
  section04: {
    aboutUs_01: {
      title: "100% Satisfaction",
      content:
        "Whether it's elegant draperies, roller blinds, or shutters you require, we will work with you to ensure that your window furnishings not only complete your architectural vision but possesses the enduring performance to withstand time."
    },
    aboutUs_02: {
      title: "Personalisation",
      content:
        "Everyone is different & unique. Our designs come in wide range of styles, fabrics, patterns. We have something for every home. Allow us to assist you in creating your perfect window dressing!"
    },
    aboutUs_03: {
      title: "Warranty",
      content:
        "We provide five years warranty for all products. Although we are confident in our products’ quality, we are more than happy to be of assistance should you encounter any issues."
    },
    aboutUs_04: {
      title: "We come to you",
      content:
        "We provide you professional non-obligatory consultation and quotation for your window dressing."
    },
    aboutUs_05: {
      title: "Customer service",
      content:
        "You will enjoy the highest standard of customer service from quotation right through to installation."
    },
    aboutUs_06: {
      title: "Best price Guarantee",
      content:
        "We do our best to always offer you the lowest price, but if you find a lower  price on another site, we will be happy to match it and give you 15% off that product."
    }
  }
};
